import { useMemo, useState } from 'react';
import { ChiTietHoaDonBanHangDichVu, HoaDonBanHangDichVu } from '@/types/schemas';
import { getDataTableColumns } from '../cols-definition';

export const useTableData = (
  hoaDonBanDichVus: HoaDonBanHangDichVu[],
  handleViewClick: (row: HoaDonBanHangDichVu) => void,
  totalAmountData?: number | null,
  isTotalLoading?: boolean
) => {
  const [detailRows, setDetailRows] = useState<ChiTietHoaDonBanHangDichVu[]>([]);

  const { totalAmount, totalDiscount, totalTax } = useMemo(() => {
    const amount = detailRows.reduce((sum, row) => sum + (row.tien_nt2 || 0), 0);
    const discount = detailRows.reduce((sum, row) => sum + (row.ck_nt || 0), 0);
    const tax = detailRows.reduce((sum, row) => sum + (row.thue_nt || 0), 0);
    return { totalAmount: amount, totalDiscount: discount, totalTax: tax };
  }, [detailRows]);

  const tables = [
    {
      name: 'Tất cả',
      rows: hoaDonBanDichVus,
      columns: getDataTableColumns(handleViewClick, totalAmountData, isTotalLoading)
    },
    {
      name: 'Chưa ghi sổ',
      rows: hoaDonBanDichVus.filter(row => row.status === '0'),
      columns: getDataTableColumns(handleViewClick, totalAmountData, isTotalLoading),
      icon: <div className='mr-2 size-[7px] rounded-full bg-[#EAD1DC]' />
    },
    {
      name: 'Đã ghi sổ',
      rows: hoaDonBanDichVus.filter(row => row.status === '3'),
      columns: getDataTableColumns(handleViewClick, totalAmountData, isTotalLoading),
      icon: <div className='mr-2 size-[7px] rounded-full bg-[#3D85C6]' />
    },
    {
      name: 'Chờ duyệt',
      rows: hoaDonBanDichVus.filter(row => row.status === '5'),
      columns: getDataTableColumns(handleViewClick, totalAmountData, isTotalLoading),
      icon: <div className='mr-2 size-[7px] rounded-full bg-red-500' />
    },
    {
      name: 'Khác',
      rows: hoaDonBanDichVus.filter(row => row.status !== '0' && row.status !== '3' && row.status !== '5'),
      columns: getDataTableColumns(handleViewClick, totalAmountData, isTotalLoading),
      icon: <div className='mr-2 size-[7px] rounded-full bg-black' />
    }
  ];

  return {
    hoaDonBanDichVus,
    detailRows,
    totalAmount,
    totalDiscount,
    totalTax,
    tables,
    setDetailRows
  };
};
